import store from '@/store'
import _Vue from 'vue'

const getLanguage = () => {
  const lang = store.state.profile?.lang || 'es'
  switch (lang) {
    case 'es':
      return 'es-ES'
    case 'en':
    default:
      return 'en-US'
  }
}

interface FormatType {
  asNumber: (value: string | number, minimumFractionDigits?: number) => string
  asCurrency: (value: string | number, minimumFractionDigits?: number) => string
  asDate: (date: string) => string
  asLongDate: (date: string) => string
}

const format = () => ({
  asNumber: (value: number | string, minimumFractionDigits = 2) =>
    Number(value).toLocaleString('en-US', {
      minimumFractionDigits,
    }),
  asCurrency: (value: number | string, minimumFractionDigits = 2) =>
    Number(value).toLocaleString('en-US', {
      minimumFractionDigits,
      style: 'currency',
      currency: 'USD',
    }),
  asDate: (date: string) =>
    new Date(date).toLocaleDateString(getLanguage(), {
      // @ts-ignore
      dateStyle: 'medium',
    }),
  asLongDate: (date: string) =>
    new Date(date).toLocaleDateString(getLanguage(), {
      // @ts-ignore
      dateStyle: 'full',
    }),
  asShortDate: (date: string) =>
    new Date(date).toLocaleDateString(getLanguage(), {
      // @ts-ignore
      dateStyle: 'short',
    }),
  asDateTime: (date: string) =>
    new Date(date).toLocaleString(getLanguage(), {
      // @ts-ignore
      dateStyle: 'medium',
      timeStyle: 'medium',
      hour12: true,
    }),
})

declare module 'vue/types/vue' {
  interface Vue {
    $format: ReturnType<typeof format>
  }
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$format = format()
  },
}
